const { parseDomain } = require('parse-domain')
const languageMap = require('../../i18n/languageMap')

module.exports = hostname => {
  if (
    hostname.indexOf('localhost') !== -1 ||
    hostname.indexOf('staging') !== -1
  ) {
    return 'en'
  }

  const { topLevelDomains, subDomains } = parseDomain(hostname)
  let topLevelDomain = null

  try {
    topLevelDomain = topLevelDomains[0]
  } catch {
    console.log(`[ERROR] getLanguageFromHostname: ${hostname}`)
  }

  if (topLevelDomain === 'pizza') {
    let devLanguage = subDomains[0]

    if (devLanguage.indexOf('-') !== -1) {
      const parts = devLanguage.split('-')
      devLanguage = `${parts[0]}-${parts[1].toUpperCase()}`
    }

    switch (devLanguage) {
      case 'com':
        return 'en'
      case 'at':
        return 'de'
      case 'uk':
        return 'en'
      case 'com-BR':
        return 'pt-BR'
      case 'fr-BE':
        return 'fr'
      case 'fr-CH':
        return 'fr'
      default:
        return devLanguage
    }
  }

  const languageFromMap = languageMap[hostname]
  if (languageFromMap === 'pt-BR') return languageFromMap
  const onlyLanguage =
    (languageFromMap && languageFromMap.split('-')[0]) || 'en'
  return onlyLanguage
}
